module.exports = __webpack_public_path__ + "img/img-1-1200x1000.71ac78d1.jpg";